import {StyleSheet} from 'react-native';
import {colorPalette, textStyles} from '../../../../theme';

export default StyleSheet.create({
  container: {
    alignSelf: 'stretch',
    marginHorizontal: 16,
    marginTop: 60,
  },
  rowContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  rowValue: {
    fontFamily: textStyles.medium,
    fontSize: 13,
    color: colorPalette.grey6,
  },
  title: {
    fontFamily: textStyles.medium,
    fontSize: 13,
    color: colorPalette.grey6,
  },
  amountPayable: {
    color: colorPalette.grey9,
  },
});
